// Transcription de la dictée vocale (voir ui/dictation.ts).
import { getPraetoriaApiToken, PRAETORIA_API_BASE_URL } from "../config";
import { PraetoriaTimeoutError, SERVICE_UNAVAILABLE_MESSAGE, TranscriptionError } from "./errors";

const TRANSCRIBE_TIMEOUT_MS = 45000;

export async function transcribeInstruction(audio: Blob, graphToken: string): Promise<string> {
  const token = getPraetoriaApiToken();
  if (!token) {
    throw new Error("Token API Praetoria manquant (PRAETORIA_API_TOKEN).");
  }

  const formData = new FormData();
  formData.append("audio", audio, "consigne.webm");
  formData.append("graph_access_token", graphToken);

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), TRANSCRIBE_TIMEOUT_MS);

  let response: Response;
  try {
    response = await fetch(`${PRAETORIA_API_BASE_URL}/app/email/speech/transcribe`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
      signal: controller.signal,
    });
  } catch (error) {
    if (error instanceof Error && error.name === "AbortError") {
      throw new PraetoriaTimeoutError();
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }

  if (!response.ok) {
    if (response.status === 400) {
      throw new TranscriptionError(400, "Enregistrement invalide (vide ou trop long).");
    }
    if (response.status === 401) {
      throw new TranscriptionError(401, "Session Microsoft expirée, rechargez le module.");
    }
    if (response.status === 429) {
      throw new TranscriptionError(429, "Trop de dictées récentes, réessayez dans quelques instants.");
    }
    if (response.status === 503) {
      throw new TranscriptionError(503, SERVICE_UNAVAILABLE_MESSAGE);
    }
    throw new TranscriptionError(response.status, "Échec de la transcription, réessayez.");
  }

  const data = await response.json();
  return data.text;
}
